/**
 * Key per i menu items statici (non-moduli).
 */
export enum SubmissionMenuKey {
  Report = 'report',
  Guide = 'guide',
  Payment = 'payment',
}
